<template>
  <div>
    <action-menu-wrapper
      :items="options"
      :offset="offset"
      :teleport="teleport"
    />

    <confirm-modal
      v-if="showDeleteModal"
      :title="`${$t('COMMON.DELETE')} ${$t('CUSTOM_WEBHOOKS.TITLE')}`"
      :description="
        $t('ORGANIZATION.COMMUNICATION_TEMPLATES.DELETE_DESCRIPTION', {
          name: model.name,
        })
      "
      :confirm-button="$t('COMMON.DELETE')"
      confirm-button-type="error"
      :close="() => (showDeleteModal = false)"
      @confirm="deleteCustomWebhook"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import { COMMON_MENU_OFFSET } from "@/helpers/constants";

import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import ActionMenuWrapper, {
  type MenuItem,
} from "@/components/ui/ActionMenuWrapperV2.vue";

import type { CustomWebhook } from "@/models/customWebhook";

const emit = defineEmits<{
  "webhook:edit": [id: CustomWebhook["id"]];
  "webhook:duplicate": [id: CustomWebhook["id"]];
  "webhook:delete": [id: CustomWebhook["id"]];
}>();

const { model, teleport = true } = defineProps<{
  model: CustomWebhook;
  teleport?: boolean;
}>();

const offset = COMMON_MENU_OFFSET;

const { t } = useI18n();

const showDeleteModal = ref(false);

const editWebhook = () => {
  if (model) {
    emit("webhook:edit", model.id);
  }
};

const deleteCustomWebhook = () => {
  if (model) {
    emit("webhook:delete", model.id);
  }
};

const options: MenuItem[] = [
  {
    label: t("COMMON.EDIT"),
    handler: editWebhook,
  },
  {
    label: t("COMMON.DELETE"),
    handler: () => (showDeleteModal.value = true),
  },
];
</script>
